require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-liverfoundation-risk.json") })
        }
      }, "path---article-liverfoundation-risk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-liverfoundation-risk!./.cache/json/article-liverfoundation-risk.json
// module id = 346
// module chunks = 231608221292675